import { action, ActionType } from 'typesafe-actions';
import { SaveStatus } from './draftSaveStatus.types';

export const SET_AUTO_SAVE_STATUS = 'draftSaveStatus/SET_AUTO_SAVE_STATUS';
export const SET_MANUAL_SYNC_STATUS = 'draftSaveStatus/SET_MANUAL_SYNC_STATUS';
export const SET_FORM_DIRTY = 'draftSaveStatus/SET_FORM_DIRTY';
export const RESET_SAVE_STATUS = 'draftSaveStatus/RESET_SAVE_STATUS';

export const setAutoSaveStatus = (status: SaveStatus) => action(SET_AUTO_SAVE_STATUS, { status });
export const setManualSyncStatus = (status: SaveStatus) => action(SET_MANUAL_SYNC_STATUS, { status });
export const setFormDirty = (dirty: boolean) => action(SET_FORM_DIRTY, { dirty });
export const resetSaveStatus = () => action(RESET_SAVE_STATUS);

const actions = { setAutoSaveStatus, setManualSyncStatus, setFormDirty, resetSaveStatus };
export type DraftSaveStatusAction = ActionType<typeof actions>;
